import { Paper, Skeleton, Typography } from '@mui/material'
import React from 'react'
import ChairTitle from '../atoms/ChairTitle'
import BodyHeader from '../molecules/BodyHeader'
import CardLeftRight from '../molecules/CardLeftRight'
import Figures from '../molecules/Figures'
import TitleSubtitle from '../molecules/TitleSubtitle'
import Zone from '../organisms/Zone'

import useFigures from '../../hooks/useFigures'

import strips from '../../media/strips.svg'
import Slide from '../molecules/Slide'

import useEmploymentSupport from '../../hooks/useEmploymentSupport'
import { CATEGORIES, SERVICES } from '../../constants'
import useDefault from '../../hooks/useDefault'
import useRemark from '../../hooks/useRemark'

const EmploymentSupport = () => {
	const { isLoading, title, content } = useEmploymentSupport()
	const { figures } = useFigures(CATEGORIES.FIGURES.ACCOMPAGNEMENT.id)

	const { data: parcours } = useDefault(SERVICES.PARCOURS)

	const PER_PAGE = 5
	const { remarks } = useRemark(CATEGORIES.COMMENTS.ACCOMPAGNEMENT.id, PER_PAGE)

	return (
		<>
			{(isLoading && <Skeleton />) || <BodyHeader title={title}>{content}</BodyHeader>}

			{parcours && (
				<Zone color="ivory">
					<TitleSubtitle
						title="Parcours d’accompagnement"
						subtitle="Les ressourceries solidaires : un outil au service de l’accompagnement des plus fragiles"
					/>
					{parcours?.list?.map(({ title, content, srcset, image }, index) => (
						<CardLeftRight src={srcset} key={index} hasRightTitle={index % 2 === 1} image={image}>
							<ChairTitle label={title} />
							<Typography
								component="p"
								sx={{ fontSize: 18, fontWeight: 400, mb: 1 }}
								dangerouslySetInnerHTML={{ __html: content }}
							/>
						</CardLeftRight>
					))}
				</Zone>
			)}

			{remarks && (
				<Paper
					sx={(theme) => ({
						bgcolor: 'primary.main',
						borderRadius: 0,
						textAlign: 'center',
						p: (theme) => theme.spacing(16, 14),
						backgroundImage: `url(${strips})`,
						backgroundRepeat: 'round no-repeat',

						backrgoundPosition: '0 0',
						[theme.breakpoints.down('md')]: {
							p: theme.spacing(10, 3),
							backgroundRepeat: 'no-repeat',
						},
					})}
				>
					<Slide list={remarks} />
				</Paper>
			)}
			<Zone color="black">
				<TitleSubtitle
					subtitle="La Collecterie en chiffres"
					title="depuis 2012"
					color="white"
					titleColor="white"
					inverseTitle
				/>
				{figures && <Figures list={figures} />}
			</Zone>
		</>
	)
}

export default EmploymentSupport
